import RichText from '@/components/RichText'
import SyllabusListing from '@/components/syllabus-table/SyllabusListing'
import { CommonCopyUrlWrapper } from '@/components/ui/copy-to-clipboard/CommonCopyUrlWrapper'
import UnknownComponent from '@/components/UnknownComponent'
import { useCleanPathDefault } from '@/hooks/useCleanPathDefault'
import { WebUiSyllabusTile } from '@/kontent/content-types'
import type { WpLearningarea as WpLearningareaModel } from '@/kontent/content-types/wp_learningarea'
import type { CommonPageProps, TaxoStageGroupWithLifeSkill } from '@/types'
import { getPageTypeName } from '@/utils/gtmTracking'
import { ElementModels, Responses } from '@kontent-ai/delivery-sdk'
import { useRouter } from 'next/router'
import { Fragment } from 'react'

type LearningAreaWithStages = CommonPageProps<WpLearningareaModel> & {
	data: {
		syllabusTiles: Responses.IListContentItemsResponse<WebUiSyllabusTile>
		stageGroups: ElementModels.TaxonomyTerm<TaxoStageGroupWithLifeSkill>[]
	}
}

function WpLearningArea(props: LearningAreaWithStages) {
	const { pageResponse, syllabusTiles } = props.data
	const page = pageResponse.item
	const router = useRouter()
	const currentUrl = useCleanPathDefault()
	const { stageGroups } = props.data

	if (!page) {
		return (
			<UnknownComponent>
				Page {page.system.codename} does not have any content!
			</UnknownComponent>
		)
	}

	return (
		<Fragment key={page.system.id}>
			{page.elements.title.value && (
				<CommonCopyUrlWrapper url={currentUrl} className="mb-8">
					<h1
						data-kontent-item-id={page.system.id}
						data-kontent-element-codename="title"
					>
						{page.elements.title.value}
					</h1>
				</CommonCopyUrlWrapper>
			)}
			<RichText
				className="w-full"
				currentPath={router.asPath}
				mappings={props.mappings}
				linkedItems={pageResponse.linkedItems}
				richTextElement={page.elements.web_content_rtb__content}
				currentKeyLearningAreas={
					page.elements.key_learning_area__items.value
				}
				pageType={getPageTypeName(page.system.type)}
			/>
			<SyllabusListing
				items={syllabusTiles.items}
				linkedItems={syllabusTiles.linkedItems}
				mappings={props.mappings}
				stageFilterData={stageGroups ? stageGroups : null}
			/>
		</Fragment>
	)
}

export default WpLearningArea
